import { useCallback, useEffect, useState } from "react";
import { Search, RefreshCw } from "lucide-react";
import { api, errorMessage } from "../api";

export const CHANGE_LABEL = { increase: "Qty increased", reduce: "Qty reduced", cancel: "Cancelled", note: "Note changed" };

export function fmtDateTime(iso) {
  const d = new Date(iso);
  const p = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }).formatToParts(d);
  const g = (t) => p.find((x) => x.type === t)?.value;
  return `${g("day")}-${g("month")}-${g("year")} ${g("hour")}:${g("minute")} ${(g("dayPeriod") || "").toUpperCase()}`;
}

export function ModRow({ m }) {
  return (
    <tr data-testid={`kot-mod-${m.id}`}>
      <td><b>{m.item_name}</b><span>{m.kot_no} → {m.mod_kot_no}</span></td>
      <td><span className={`pill mod-${m.change}`} data-testid={`kot-mod-change-${m.id}`}>{CHANGE_LABEL[m.change]}</span></td>
      <td>{m.old_qty} → {m.new_qty}{m.new_notes !== m.old_notes && <span>“{m.new_notes || "—"}”</span>}</td>
      <td>{m.table_label}</td>
      <td>{m.reason || "—"}</td>
      <td>{m.by_name}<span>{(m.by_role || "").toUpperCase()}</span></td>
      <td>{fmtDateTime(m.at)}</td>
    </tr>
  );
}

export function ModTable({ rows, testid }) {
  return (
    <div className="table-wrap"><table data-testid={testid}>
      <thead><tr><th>Item / KOT</th><th>Change</th><th>Qty / note</th><th>Table</th><th>Reason</th><th>By</th><th>When (IST)</th></tr></thead>
      <tbody>
        {!rows.length && <tr><td colSpan={7}><div className="empty small">No modifications recorded.</div></td></tr>}
        {rows.map((m) => <ModRow key={m.id} m={m} />)}
      </tbody>
    </table></div>
  );
}

export default function KotHistoryView({ branch }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ change: "", q: "", date_from: "", date_to: "" });
  const [err, setErr] = useState("");
  const load = useCallback(async () => {
    try {
      const qs = new URLSearchParams({ branch, ...f }).toString();
      setRows((await api.get(`/kot-history?${qs}`)).data); setErr("");
    } catch (e) { setErr(errorMessage(e)); }
  }, [branch, f]);
  useEffect(() => { load(); }, [load]);
  const upd = (k, v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <div className="panel full-panel" data-testid="kot-history-page">
      <div className="filters kot-filters">
        <div className="search"><Search size={14} /><input placeholder="Item, table, KOT, staff, reason" value={f.q} onChange={(e) => upd("q", e.target.value)} data-testid="kot-history-search" /></div>
        <select value={f.change} onChange={(e) => upd("change", e.target.value)} data-testid="kot-history-change-filter">
          <option value="">All changes</option>
          {Object.entries(CHANGE_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <label>From<input type="date" lang="en-GB" value={f.date_from} onChange={(e) => upd("date_from", e.target.value)} data-testid="kot-history-from" /></label>
        <label>To<input type="date" lang="en-GB" value={f.date_to} onChange={(e) => upd("date_to", e.target.value)} data-testid="kot-history-to" /></label>
        <span className="filter-spacer" />
        <span className="muted-label" data-testid="kot-history-count">{rows.length} entries</span>
        <button className="icon-button" onClick={load} data-testid="kot-history-refresh"><RefreshCw size={14} /></button>
      </div>
      {err && <div className="auth-alert error" style={{ margin: 16 }}>{err}</div>}
      <ModTable rows={rows} testid="kot-history-table" />
    </div>
  );
}
